import type { FieldStateHelperAPI, FormikFieldStateHelperParams } from "./fieldStateHelper.types";
import type { FieldValues } from "react-hook-form";

export const formikFieldStateHelper = <FormType extends FieldValues>({
    errors,
    touched,
    isSubmitted,
}: FormikFieldStateHelperParams<FormType>): FieldStateHelperAPI => {
    const isFieldInvalid = (fieldName: string) => {
        const error = getFieldError(fieldName);
        const isTouched = isFieldTouched(fieldName);
        return Boolean(error) && Boolean(isTouched);
    };

    const getFieldError = (fieldName: string) => {
        return errors?.[fieldName] as string | undefined;
    };

    const isFieldTouched = (fieldName: string) => {
        return Boolean(touched?.[fieldName]) || Boolean(isSubmitted);
    };

    const isFieldSuccess = (fieldName: string) => {
        return Boolean(!errors?.[fieldName] && isFieldTouched(fieldName));
    };

    const getFieldStateProps = (fieldName: string) => {
        return {
            isInvalid: isFieldInvalid(fieldName),
            isSuccess: isFieldSuccess(fieldName),
            error: getFieldError(fieldName),
        };
    };

    const getIconProps: FieldStateHelperAPI["getIconProps"] = (fieldName) => {
        const isSuccess = isFieldSuccess(fieldName);
        if (isSuccess) {
            return {
                rightIcon: "ok",
            };
        }
        return {};
    };

    return {
        isFieldInvalid,
        getFieldError,
        isFieldTouched,
        isFieldSuccess,
        getFieldStateProps,
        getIconProps,
    };
};
